module.exports = __webpack_public_path__ + "static/media/view-user.9a1d9aef.svg";